export const isNil = (value) => value === null || value === undefined;

export const isBlank = (value) => isNil(value) || value === "";

export const stripTrailingSpaces = (value) => {
  if (typeof value !== "string") return value;
  return value.trimEnd();
};

export const getPath = (object, path) => {
  if (isNil(object) || isNil(path) || path === "") return undefined;
  return String(path)
    .split(".")
    .reduce(
      (current, key) => (isNil(current) ? undefined : current[key]),
      object,
    );
};
